import { db, storage } from '@/config/firebase';
import _ from 'lodash';


function processCompanyData(companiesObj, doc) {
    let companyObj = doc.data();
    companyObj['id'] = doc.id;
    companiesObj[doc.id] = companyObj;
}

async function getAllCompanies() {
    let companiesObj = {};

    const query = db.collection('companies').orderBy("name");
    const querySnapshot = await query.get();

    querySnapshot.forEach((doc) => {
        processCompanyData(companiesObj, doc);
    });

    return companiesObj;
}

async function getChildrenCompanies(parentCompanyId) {
    let companiesObj = {};

    const query = db.collection('companies').where('parentCompanyId', '==', parentCompanyId)
    const querySnapshot = await query.get();

    querySnapshot.forEach((doc) => {
        processCompanyData(companiesObj, doc);
    });

    return companiesObj;
}

async function getCompanyByID(companyId) {
    const query = db.collection('companies').doc(companyId);
    const querySnapshot = await query.get();
    return querySnapshot.data();
}

async function addCompany(companyObj) {
    const companyRef = db.collection('companies').doc();
    await companyRef.set(companyObj);
    return companyRef.id;
}

async function updateLguTaglineLogo(docId, imageObj) {
    let query = db.collection('companies').doc(docId);
    return query.set(imageObj, { merge: true });
}

async function updateCompanyLogo(docId, companyLogo) {
    let query = db.collection('companies').doc(docId);
    return query.set(companyLogo, { merge: true });
}

async function updateCompany(companyObj) {
    const companyRef = db.collection('companies').doc(companyObj.id);
    await companyRef.set(companyObj, { merge: true });
    return companyObj.id;
}

async function updateCompanyMainHub(companyId, hubObj) {
    let query = db.collection('companies').doc(companyId);

    let mainHub = {}

    if (!_.isEmpty(hubObj)) {
        mainHub = {
            id: hubObj.id,
            name: hubObj.name,
            qrcode: hubObj.qrcode
        }
    }

    return query.update({ mainHub });
}

// Delete file from bucket and update document
async function deleteLguTaglineLogo(companyId) {
    const query = await db.collection('companies').doc(companyId).get();
    const data = query.exists ? query.data() : null;
    const storageRef = storage.ref();

    if (data.lguPic && data.lguPic.name) {
        const imageRef = storageRef.child(`images/lgus/${data.lguPic.name}`);
        await imageRef.delete();
        await updateLguTaglineLogo(companyId, { image: {} });
    }
}

async function deleteCompanyLogo(docId) {
    const query = await db.collection('companies').doc(docId).get();
    const data = query.exists ? query.data() : null;
    const storageRef = storage.ref();

    if (data.companyLogo && data.companyLogo.name) {
        const imageRef = storageRef.child(`images/companyLogos/${data.companyLogo.name}`);
        await imageRef.delete();
        await updateCompanyLogo(docId, { companyLogo: {} });
    }
}

export default {
    getAllCompanies,
    getChildrenCompanies,
    getCompanyByID,
    addCompany,
    updateCompany,
    updateLguTaglineLogo,
    deleteLguTaglineLogo,
    updateCompanyMainHub,
    updateCompanyLogo,
    deleteCompanyLogo
}